module.exports = __webpack_public_path__ + "static/media/1002242.0aac51e0.png";